import { ActiveTourDetailModel, ActiveTourModel, CustomsDetails, DashboardModel, GetActiveTourDetailsQuery, GetAllActiveTourDetailsQuery, GetMyCustomsHistoryQuery, GetMyTourHistoryQuery, PagedListingResponseOfTourListHistoryModel, TourModel } from "@core/services/api.service";

export class LoadMyTourListAction {
    static readonly type = '[MyManagedTourList] Load Tour list';
}

export class LoadMyTourListSuccessAction {
    static readonly type = '[MyManagedTourList] Load Tour list Success';

    constructor(public payload: { tours: TourModel[] }) { }
}

export class LoadMyTourListFailAction {
    static readonly type = '[MyManagedTourList] Load Tour list Fail';
}



export class LoadActiveTourListAction {
    static readonly type = '[MyManagedTourList] Load Active Tour list';
}

export class LoadActiveTourListSuccessAction {
    static readonly type = '[MyManagedTourList] Load Active Tour list Success';

    constructor(public payload: { tours: ActiveTourModel[] }) { }
}

export class LoadActiveTourListFailAction {
    static readonly type = '[MyManagedTourList] Load Active Tour list Fail';
}

export class LoadMyTourHistoryListAction {
    static readonly type = '[MyTourHistoryList] Load Tour History list';
    constructor(public payload: { GetMyTourHistoryQuery: GetMyTourHistoryQuery }) { }
}

export class LoadMyTourHistoryListSuccessAction {
    static readonly type = '[MyTourHistoryList] Load Tour History list Success';

    constructor(public payload: { tourHistoryList: PagedListingResponseOfTourListHistoryModel }) { }
}

export class LoadMyTourHistoryListFailAction {
    static readonly type = '[MyTourHistoryList] Load Tour History list Fail';
}



export class LoadMyTourListDetailsAction {
    static readonly type = '[MyTourHistoryList] Load Tour Details list';
    constructor(public payload: { GetActiveTourDetailsQuery: GetActiveTourDetailsQuery }) { }
}

export class LoadMyTourListDetailsSuccessAction {
    static readonly type = '[MyTourHistoryList] Load Tour list Details Success';

    constructor(public payload: { activeTourDetails: ActiveTourDetailModel }) { }
}

export class LoadMyTourListDetailsFailAction {
    static readonly type = '[MyTourHistoryList] Load Tour list Details Fail';
}

export class LoadAllActiveToursListAction {
    static readonly type = '[MyTourHistoryList] Load All Active Tour Details list';
    constructor(public payload: { GetAllActiveTourDetailsQuery: GetAllActiveTourDetailsQuery }) { }
}

export class ClearActiveToursAction {
    static readonly type = '[MyTourHistoryList] Clear tours';
}

export class LoadAllActiveToursListSuccessAction {
    static readonly type = '[MyTourHistoryList] Load All Active Tour list Details Success';

    constructor(public payload: { allActiveTourDetails: ActiveTourDetailModel[] }) { }
}

export class LoadAllActiveToursListFailAction {
    static readonly type = '[MyTourHistoryList] Load All Active Tour list Details Fail';
}

export class AddSelectedActiveTourIdsAction  {
    static readonly type = '[SelectedActiveTourIds] Add Selected Active TourIds IDs';
    constructor(public payload:{ Ids: number[]}) {}
}
export class AddSelectedActiveTourIdAction {
    static readonly type = '[SelectedActiveTourIds] Add Selected Active TourId';
    constructor(public payload:{Id: number}) {}
  }

  export class RemoveSelectedActiveTourIdAction {
    static readonly type = '[SelectedActiveTourIds] Remove Selected Active TourId';
    constructor(public payload:{ Id: number}) {}
  }
  export class RemoveAllSelectedActiveTourIdAction {
    static readonly type = '[SelectedActiveTourIds] Remove All Selected Active TourId';
}

export class LoadMyCustomsListAction {
    static readonly type = '[MyTours] Load My Customs List';
}

export class LoadMyCustomsListSuccessAction {
    static readonly type = '[MyTours] Load My Customs List Success';
    constructor(public payload: { customsList: CustomsDetails[] }) {}
}

export class LoadMyCustomsListFailAction {
    static readonly type = '[MyTours] Load My Customs List Fail';
}

export class LoadMyCustomsDashboardAction {
    static readonly type = '[MyTours] Load My Customs Dashboard';
}

export class LoadMyCustomsDashboardSuccessAction {
    static readonly type = '[MyTours] Load My Customs Dashboard Success';
    constructor(public payload: { dashboards: DashboardModel[] }) {}
}

export class LoadMyCustomsDashboardFailAction {
    static readonly type = '[MyTours] Load My Customs Dashboard Fail';
}

export class LoadMyCustomsHistoryListAction {
    static readonly type = '[MyTours] Load My Customs History List';
    constructor(public payload: { GetMyCustomsHistoryQuery: GetMyCustomsHistoryQuery }) {}
}

export class LoadMyCustomsHistoryListSuccessAction {
    static readonly type = '[MyTours] Load My Customs History List Success';
    constructor(public payload: { customsHistoryList: PagedListingResponseOfTourListHistoryModel }) {}
}

export class LoadMyCustomsHistoryListFailAction {
    static readonly type = '[MyTours] Load My Customs History List Fail';
}